import {
  DISPATCH_BOARD_LIST_REQUEST,
  DISPATCH_BOARD_LIST_SUCCESS,
  DISPATCH_BOARD_LIST_FAIL,
  DISPATCH_BOARD_DATA_REQUEST,
  DISPATCH_BOARD_DATA_SUCCESS,
  DISPATCH_BOARD_DATA_FAIL,
  DISPATCH_BOARD_CREATE_REQUEST,
  DISPATCH_BOARD_CREATE_SUCCESS,
  DISPATCH_BOARD_CREATE_FAIL,
  DISPATCH_BOARD_UPDATE_REQUEST,
  DISPATCH_BOARD_UPDATE_SUCCESS,
  DISPATCH_BOARD_UPDATE_FAIL,
  DISPATCH_BOARD_DELETE_REQUEST,
  DISPATCH_BOARD_DELETE_SUCCESS,
  DISPATCH_BOARD_DELETE_FAIL,
} from "./actionType";

const initialState = {
  dispatchBoardList: [],
  dispatchBoardListLoading: false,
  dispatchBoardListError: null,

  // Single board detail: config + raw assignment rows + resolved staff ids.
  dispatchBoardData: null,
  dispatchBoardStaffList: [],
  dispatchBoardSkillsetList: [],
  dispatchBoardDepartmentList: [],
  dispatchBoardResolvedStaffIds: [],
  dispatchBoardDataLoading: false,
  dispatchBoardDataError: null,

  dispatchBoardCreateLoading: false,
  dispatchBoardCreateResult: null,
  dispatchBoardCreateError: null,

  dispatchBoardUpdateLoading: false,
  dispatchBoardUpdateResult: null,
  dispatchBoardUpdateError: null,

  dispatchBoardDeleteLoading: false,
  dispatchBoardDeleteResult: null,
  dispatchBoardDeleteError: null,
};

const DispatchBoard = (state = initialState, action) => {
  switch (action.type) {
    case DISPATCH_BOARD_LIST_REQUEST:
      return { ...state, dispatchBoardListLoading: true, dispatchBoardListError: null };
    case DISPATCH_BOARD_LIST_SUCCESS:
      return {
        ...state,
        dispatchBoardListLoading: false,
        dispatchBoardList: action.payload?.dispatchboard_list || [],
      };
    case DISPATCH_BOARD_LIST_FAIL:
      return { ...state, dispatchBoardListLoading: false, dispatchBoardListError: action.payload };

    case DISPATCH_BOARD_DATA_REQUEST:
      return { ...state, dispatchBoardDataLoading: true, dispatchBoardDataError: null };
    case DISPATCH_BOARD_DATA_SUCCESS:
      return {
        ...state,
        dispatchBoardDataLoading: false,
        dispatchBoardData: action.payload?.dispatchboard_data || null,
        dispatchBoardStaffList: action.payload?.staff_list || [],
        dispatchBoardSkillsetList: action.payload?.skillset_list || [],
        dispatchBoardDepartmentList: action.payload?.department_list || [],
        dispatchBoardResolvedStaffIds: action.payload?.resolved_staff_ids || [],
      };
    case DISPATCH_BOARD_DATA_FAIL:
      return { ...state, dispatchBoardDataLoading: false, dispatchBoardDataError: action.payload };

    case DISPATCH_BOARD_CREATE_REQUEST:
      return { ...state, dispatchBoardCreateLoading: true, dispatchBoardCreateResult: null, dispatchBoardCreateError: null };
    case DISPATCH_BOARD_CREATE_SUCCESS:
      return { ...state, dispatchBoardCreateLoading: false, dispatchBoardCreateResult: action.payload };
    case DISPATCH_BOARD_CREATE_FAIL:
      return { ...state, dispatchBoardCreateLoading: false, dispatchBoardCreateError: action.payload };

    case DISPATCH_BOARD_UPDATE_REQUEST:
      return { ...state, dispatchBoardUpdateLoading: true, dispatchBoardUpdateResult: null, dispatchBoardUpdateError: null };
    case DISPATCH_BOARD_UPDATE_SUCCESS:
      return { ...state, dispatchBoardUpdateLoading: false, dispatchBoardUpdateResult: action.payload };
    case DISPATCH_BOARD_UPDATE_FAIL:
      return { ...state, dispatchBoardUpdateLoading: false, dispatchBoardUpdateError: action.payload };

    case DISPATCH_BOARD_DELETE_REQUEST:
      return { ...state, dispatchBoardDeleteLoading: true, dispatchBoardDeleteResult: null, dispatchBoardDeleteError: null };
    case DISPATCH_BOARD_DELETE_SUCCESS:
      return { ...state, dispatchBoardDeleteLoading: false, dispatchBoardDeleteResult: action.payload };
    case DISPATCH_BOARD_DELETE_FAIL:
      return { ...state, dispatchBoardDeleteLoading: false, dispatchBoardDeleteError: action.payload };

    default:
      return state;
  }
};

export default DispatchBoard;
